import { Box, Button, Grid, Typography, Card, CardContent } from '@mui/material'
import { Link } from 'react-router-dom'
import styles from './signup.module.scss'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { auth } from '../../features/authSlice.js'
import SendIcon from '@mui/icons-material/Send'
import GoogleIcon from '@mui/icons-material/Google'
import { FormInput } from '../../components/input/FormInput.jsx'
import { FacebookLoginButton } from '../../components/buttons/FacebookLoginButton.jsx'
import { LoadingSpinner } from '../../components/loadingSpinner/LoadingSpinner.jsx'
import InputCustom from '../atoms/input/InputCustom.jsx'
import ButtonCustom from '../atoms/button/ButtonCustom.jsx'

const initialFormData = {
	firstName: '',
	lastName: '',
	preferredName: '',
	email: '',
	password: '',
	confirmPassword: '',
}
const SignInForm = () => {
	const dispatch = useDispatch()
	const [formData, setFormData] = useState(initialFormData)

	const loading = useSelector((state) => state.auth.loading)

	const handleSubmit = async (e) => {
		e.preventDefault()
		dispatch(auth({ ...formData, mode: 'login' }))
	}

	const handleGoogleLogin = () => {
		const client = window.google.accounts.oauth2.initCodeClient({
			client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
			redirect_uri: `${window.location.origin}/google-redirect`,
			scope: 'email profile',
			state: 'login',
			ux_mode: 'redirect',
		})
		client.requestCode()
	}
	return (
		<form className={styles.form} onSubmit={handleSubmit}>
			<div className={styles.formGroup}>
				<InputCustom
					data-cy="email"
					placeholder="Email"
					name="email"
					type="email"
					value={formData.email}
					autoFocus={true}
					setDataFunction={setFormData}
					data={formData}
					required={true}
				/>
			</div>
			<div className={styles.formGroup}>
				<InputCustom
					data-cy="password"
					placeholder="Password"
					name="password"
					type="password"
					enableShowPassword={true}
					value={formData.password}
					setDataFunction={setFormData}
					data={formData}
					required={true}
					eyeIcon={true}
				/>
			</div>
			<div className={` ${styles.signInBtn}`}>
				<Link
					to="/forgot-password"
					data-cy="go-to-forgot-password"
					className={styles.forgotPassword}
				>
					Forgot password?{' '}
				</Link>
				<ButtonCustom variant="default" data-cy="submit" type="submit">
					{loading ? (
						<LoadingSpinner size="10px" color="#333" />
					) : (
						'Sign In'
					)}
				</ButtonCustom>
			</div>
			<div className={styles.or}>
				<Typography>or</Typography>
			</div>
			<div className={styles.socialLoginBtns}>
				<ButtonCustom variant="outlined" onClick={handleGoogleLogin}>
					<img src="/images/google-icon.svg" />
					<Typography variant="body">Continue with Google</Typography>
				</ButtonCustom>
				{/* <FacebookLoginButton /> */}
			</div>
		</form>
	)
}

export default SignInForm
